import React from 'react';
import {CallToAction, List, ListItem} from "../../styles/CommonStyler";
import {useSelector} from "react-redux";
import {FaqSection} from "../FaqSection";
import {FeatureCarousel} from "../FeatureCarousel";
import {Trans, useTranslation} from "react-i18next";
import {__isEmpty, history} from "../../_helpers";
import {ZoomPitchViewTypes} from "./pitch/ZoomPitchContents";
import {ZoomPitchView} from "./pitch/ZoomPitchView";
import {userService} from "../../_services";
import arrow_above from "../../images/arrow_above.svg";
import {sourceConstants} from "../../_constants";
import IdentifierPlayer from "../player/identifierPlayer/IdentifierPlayer";
import {GetStartedPitch} from "../pitch/GetStartedPitch";

import {
    Content,
    ContentWrapper,
    Heading,
    Section,
    SubHeading,
    SubSection,
    SubSectionItem,
    SubSections,
    Title,
    TopDescriptionItem,
    VideoConstraint,
    VideoContainer,
    VideoPitch,
    VideoPitchIcon
} from "../../styles/PromoPagesStyler"

export function ZoomIntegrationDefault(){
    const {user, isZoomAvailable} = useSelector(state => {
        const {users, authentication} = state;
        let isZoomAvailable = userService.isConnectedToZoom(users);
        return {
            user: authentication ? authentication.user : undefined,
            isZoomAvailable: isZoomAvailable
        };
    });
    const {t} = useTranslation("zoom_landing");

    return (
        <>
        <ContentWrapper>
        <Content>

            <Section>
                <SubSections>
                    <SubSection>
                        <Title>{t("Gistify & Zoom ... Collaborate & Visualize Key Moments")}</Title>
                        <TopDescriptionItem><Trans i18nKey="tag-1">
                            Effectively and remotely collaborate, creating and utilizing Gistify's <em>actionable
                            transcripts</em> in a variety of legal settings. Gistify is a rolling abstract and
                            keyword visualization built from your audio and video content that dramatically extends
                            the usefulness of legal transcripts.
                        </Trans></TopDescriptionItem>
                    </SubSection>
                    <SubSection>
                        <ZoomPitchView
                            viewType={ZoomPitchViewTypes.LANDING}
                            isLoggedIn={!__isEmpty(user)}
                            isZoomAvailable={isZoomAvailable}
                            margin="0px"
                        />
                    </SubSection>
                </SubSections>
            </Section>

            <Section>
                <SubSections>
                    <VideoContainer>
                        <VideoConstraint>
                            <IdentifierPlayer
                                identifier={sourceConstants.SOURCE_DEFAULT.ZOOM}
                            />
                        </VideoConstraint>
                    </VideoContainer>
                </SubSections>
            </Section>
            <VideoPitch>{t('Try it out')}<VideoPitchIcon src={arrow_above} /></VideoPitch>

            <Section>
                <SubSections>
                    <SubSection align="center">
                        <SubSectionItem>
                            <FeatureCarousel/>
                        </SubSectionItem>
                        { !user && <SubSectionItem>
                            <CallToAction onClick={() => history.push('/signup')}>{t("Start Your Free Trial")}</CallToAction>
                        </SubSectionItem> }
                    </SubSection>
                    <SubSection>
                        <SubHeading>{t("Key Uses & Benefits")}</SubHeading>
                        <p>{t("The first time you're able to find that key moment so easily, you may ask yourself why you'd not been using Gistify earlier.")}</p>
                        <List>
                            <ListItem><Trans i18nKey={"key-use-1"}>Create an <em>actionable transcript</em> derived from any recorded media</Trans></ListItem>
                            <ListItem>{t("Collaborate & record via Zoom")}</ListItem>
                            <ListItem>{t("See and hear all parties on any device")}</ListItem>
                            <ListItem>{t("Effortless navigation")}</ListItem>
                            <ListItem>{t("Share with your team")}</ListItem>
                        </List>
                        <p>{t("So, why are you still reviewing hardcopy transcripts or depending on random media searches to possibly find something specific?")}</p>
                    </SubSection>
                </SubSections>
            </Section>

            <Section>
                <SubSections>
                    <SubSection>
                        <FaqSection/>
                    </SubSection>
                </SubSections>
            </Section>

            <Section>
                <Heading>{t("Select Use Cases")}</Heading>
                <SubSections>
                    <SubSection>
                        <SubHeading>{t("Find & Share Key Points")}</SubHeading>
                        <List>
                            <ListItem>{t("Easily scan your Zoom recordings")}</ListItem>
                            <ListItem>{t("Find that relevant moment")}</ListItem>
                            <ListItem>{t("Share Gists with your team")}</ListItem>
                        </List>
                    </SubSection>
                    <SubSection>
                        <SubHeading>{t("Scan a Rolling Abstract")}</SubHeading>
                        <List>
                            <ListItem>{t("Is that the meeting referencing the info you need?")}</ListItem>
                            <ListItem>{t("Traverse a Gist to assess meaning")}</ListItem>
                        </List>
                    </SubSection>
                    <SubSection>
                        <SubHeading>{t("Risk Free, 30-Day Trial")}</SubHeading>
                        <List>
                            <ListItem>{t("Sign up for a free account today!")}</ListItem>
                            <ListItem>{t("Check out benefits of Gistify on your productivity...")}</ListItem>
                        </List>
                    </SubSection>
                </SubSections>
            </Section>

        </Content>
        </ContentWrapper>

        {!user &&
            <GetStartedPitch/>
        }

        </>
    )
}